import { render } from "./recruitRanking.vue?vue&type=template&id=dd2213e2&scoped=true"
import script from "./recruitRanking.vue?vue&type=script&lang=js"
export * from "./recruitRanking.vue?vue&type=script&lang=js"

import "./recruitRanking.vue?vue&type=style&index=0&id=dd2213e2&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd2213e2"]])

export default __exports__